import { getField, updateField } from "vuex-map-fields";
import ovsesRmtancAplcnInfoInptReq from "./ovsesRmtancAplcnInfoInptReq";

const getDefaultState = () => {
  return {
    /* 환율조회 */
    RBF0470140: {
      requestData: {},
      responseData: {},
    },
    RBF0470140Detail: {},
    /* 검색조건 */
    srch: {
      date: "",
      exrtAplyNth: "",
    },
    exrtAplyNthList: [],
    baseYmd: "", //적용기준
    cnprtCncycd: "", //통화코드
  };
};

const foreignExchange = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },
  },
  actions: {
    actAllStateReset({ commit }) {
      commit("resetState");
      // commit("depositNewReq/resetState");
    },
  },
  modules: {
    ovsesRmtancAplcnInfoInptReq,
  },
};

export default foreignExchange;
